import { gql } from '@apollo/client';

export const UPDATE_GROUP_MEMBERS = gql`
  mutation UpdateGroupMembers($input: [GroupMembersInput!]!) {
    updateGroupMembers(input: $input) {
      success
    }
  }
`;
